/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as Types from '../../graph/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateQuotePdfMutationVariables = Types.Exact<{
  input: Types.GenerateQuotePdfInput;
}>;


export type GenerateQuotePdfMutation = { __typename?: 'Mutation', generateQuotePDF: { __typename?: 'GenerateQuotePDFResponse', pdf: string, filename: string } };


export const GenerateQuotePdfDocument = gql`
    mutation GenerateQuotePDF($input: GenerateQuotePDFInput!) {
  generateQuotePDF(input: $input) {
    pdf
    filename
  }
}
    `;
export type GenerateQuotePdfMutationFn = Apollo.MutationFunction<GenerateQuotePdfMutation, GenerateQuotePdfMutationVariables>;

/**
 * __useGenerateQuotePdfMutation__
 *
 * To run a mutation, you first call `useGenerateQuotePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateQuotePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateQuotePdfMutation, { data, loading, error }] = useGenerateQuotePdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateQuotePdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateQuotePdfMutation, GenerateQuotePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateQuotePdfMutation, GenerateQuotePdfMutationVariables>(GenerateQuotePdfDocument, options);
      }
export type GenerateQuotePdfMutationHookResult = ReturnType<typeof useGenerateQuotePdfMutation>;
export type GenerateQuotePdfMutationResult = Apollo.MutationResult<GenerateQuotePdfMutation>;
export type GenerateQuotePdfMutationOptions = Apollo.BaseMutationOptions<GenerateQuotePdfMutation, GenerateQuotePdfMutationVariables>;